import { inject } from '@angular/core'
import { UserDomainService } from '../../shared/domain/user.domain'
import { CanActivateFn, Router } from '@angular/router'

export function superAdminGuard(): CanActivateFn {
    return () => {
        const isSuperAdmin = inject(UserDomainService).connectedUser().superAdmin
        if (!isSuperAdmin) {
            inject(Router).navigate(['/'])
        }
        return isSuperAdmin
    }
}
